module.exports = __webpack_public_path__ + "f91c5747f67f70803378142271cc810a.mtl";